import { TextField } from 'components/mui';
import { bool, func, object, string } from 'prop-types';

/**
 * @component ContactInput
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.type
 * @param {boolean} props.required
 * @param {string} props.label
 * @param {string} props.value
 * @param {Object} props.valid
 * @param {boolean} props.valid.isErr
 * @param {string} props.valid.errMsg
 * @param {function} props.onChange
 * @returns {JSX.Element}
 */
function ContactInput(props) {
	return (
		<TextField
			data-tour={props['data-tour']}
			color="primary"
			size="medium"
			fullWidth
			variant="outlined"
			InputLabelProps={{ shrink: true }}
			type={props.type}
			name={props.name}
			autoComplete="new-password"
			required={props.required}
			label={props.label}
			value={props.value}
			error={props.valid?.isErr}
			helperText={props.valid?.errMsg}
			onChange={props.onChange}
		/>
	);
}

ContactInput.propTypes = {
	name: string,
	type: string,
	required: bool,
	label: string,
	value: string,
	valid: object,
	onChange: func,
};

export default ContactInput;
